import {
  Datagrid,
  DateField,
  FunctionField,
  useRecordContext,
  ListContextProvider,
  useList,
} from "react-admin";
import EmployeesField from "server/components/Fields/EmployeesField";

const VacationPeriodsExpanded = () => {
  const record = useRecordContext();
  const periods = record?.periods || [];
  const listContext = useList({ data: periods });

  return (
    <ListContextProvider value={listContext}>
      <Datagrid
        sx={{
          width: "50%",
          backgroundColor: theme => theme.palette.tableStripe?.main ?? theme.palette.action.hover,
          "& .RaDatagrid-headerCell": { textAlign: "left" },
          "& .RaDatagrid-headerCell:last-of-type, & .RaDatagrid-rowCell:last-of-type": { textAlign: "center" },
        }}
        bulkActionButtons={false}
        rowClick={false}
      >
        <DateField
          source="dateFrom"
          label="Начална дата"
          locales="bg-BG"
        />
        <DateField
          source="dateTo"
          label="Крайна дата"
          locales="bg-BG"
        />
        <FunctionField
          label="Работни дни"
          render={p => (p.numberOfDays > 1 ? `${p.numberOfDays} дни` : `${p.numberOfDays} ден`)}
        />
        <EmployeesField
          source="substituteEmployeeId"
          label="Заместник"
          sortable={false}
        />
      </Datagrid>
    </ListContextProvider>
  );
};

export default VacationPeriodsExpanded;
